/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    [
      'ярим тун', 'туш пайти', 'эрталаб', 'кундузи',
      'кечқурун', 'кечаси'
    ],
    ,
  ],
  ,
  [
    '00:00', '12:00', ['06:00', '11:00'], ['11:00', '18:00'], ['18:00', '22:00'],
    ['22:00', '06:00']
  ]
];
